import * as THREE from 'three';
//import THREE from 'THREE_BOOTSTRAP';
import UtilSP from 'SATPROF_UTILS/UtilSP';

export default class Tree2_grp  extends THREE.Group{
   
    /* 
    */
    private _overallLength:number;
    private W = 5; // House width
    private D = 8; // House depth
    private H = 2 * 3.5; /// Wall height to eave
    private P = 3.5; // Peak height above H
    private OHX = 1; // Roof overhang
    private tempObj:THREE.Group;
    private wallMatl:THREE.MeshPhongMaterial;
    private roofMatl:THREE.MeshPhongMaterial;
    private  walls_m:THREE.Mesh;
    private plate_g:THREE.ExtrudeGeometry;
    private roof_g:THREE.BoxGeometry;
    private roof1_m:THREE.Mesh
    private roof2_m:THREE.Mesh;


    private trunkMatl:THREE.MeshPhongMaterial;
    private layerMatl:THREE.MeshPhongMaterial;
    private layers_g:Array<THREE.CylinderGeometry>;
    private layers_m:Array<THREE.Mesh>;
    private trunk_g:THREE.CylinderGeometry;
    private trunk_m:THREE.Mesh;
    private _NLayers:number = 3;
    private _botDia:number = 10;
    private _trunkHeight:number =1.5;
    private _treeHeight:number = 20;
    private _trunkDia:number = .8;
    private _leafColor:string = "green";
    private _trunkColor:string = "brown";

    constructor(){
        super();
        //console.log("In Tree2_grp constructor...")
        this.createObject();
    }
    
    //let axesHelper = new THREE.AxesHelper( 5 );  
    private createObject(){
        this.trunkMatl = new THREE.MeshPhongMaterial( { color:this._trunkColor, side: THREE.DoubleSide } );
        this.layerMatl = new THREE.MeshPhongMaterial( { color:this._leafColor, side: THREE.DoubleSide } );

        this.tempObj = new THREE.Group();
        this.tempObj.name = "Tree_tempObj";
        this.add(this.tempObj);   
        this.refresh();
    }

    public refresh(){    

        for (let j:number = this.tempObj.children.length-1; j>= 0; j--){
            //console.log("Removing j= "+j);
            this.tempObj.remove(this.tempObj.children[j]);
        }

        //const trunkPoints:Array<THREE.Vector2> = [];

        //trunkPoints.push( new THREE.Vector2( this._trunkDia/2, 0 ) );
       // trunkPoints.push( new THREE.Vector2( this._trunkDia/2, this._trunkHeight ) );
        //this.trunk_g = new THREE.LatheGeometry( trunkPoints );

        this.trunk_g = new THREE.CylinderGeometry( this._trunkDia/2, this._trunkDia/2,  this._trunkHeight);
        this.trunk_m = new THREE.Mesh( this.trunk_g, this.trunkMatl );
        this.trunk_m.position.y = this._trunkHeight/2;
        this.trunk_m.name = "Tree_trunk_m";

        let HL:number = (this._treeHeight - this._trunkHeight)/this._NLayers;
        //let layersPoints:Array<Array<THREE.Vector2>>;
        
        //layersPoints = [];
        this.layers_g = [];
        this.layers_m = [];
        let f:number = 0.7; // taper factor 0.8
        for (let i:number=0; i<this._NLayers; i++){
            if (i < this._NLayers-1){
                f = 0.7
            } else {
                f = 0;
            }
            let RL:number = (this._botDia/2) * (1 - i /this._NLayers);
            let RT:number = (this._botDia/2) * (1 - (i+1) /this._NLayers); 
            RT = Math.max(RT, 1);
            //layersPoints[i] = [];
            //layersPoints[i].push( new THREE.Vector2( 0, 0 ) );
            //layersPoints[i].push( new THREE.Vector2( RL, 0 ) );
            //layersPoints[i].push( new THREE.Vector2( RT*f, HL ) );
            //this.layers_g[i] = new THREE.LatheGeometry( layersPoints[i] );

            this.layers_g[i] = new THREE.CylinderGeometry( RT*f, RL, HL );

            this.layers_m[i] = new THREE.Mesh( this.layers_g[i], this.layerMatl );
            this.layers_m[i].name = "Tree2 layers_m["+i+"]";
 			this.layers_m[i].position.y =  this._trunkHeight + HL*i + HL/2;
            //console.log("i= "+i+", y = "+this.layers_m[i].position.y+", HL = "+HL)
            this.tempObj.add(this.layers_m[i]);
        }

        this.tempObj.add(this.trunk_m);

        this.tempObj.position.x = 0;
        this.tempObj.position.y = 0;
    }

	public set NLayers(v){   
        this._NLayers = v;	    
        this.refresh();		
    }
	public get NLayers(){   
        return this._NLayers;		
    }
	public set bottomDiameter(v){   
        this._botDia = v;	    
        this.refresh();		
    }
	public get bottomDiameter(){   
        return this._botDia;		
    } 
	public set trunkHeight(v){   
        this._trunkHeight = v;	    
        this.refresh();		
    }
	public get trunkHeight(){   
        return this._trunkHeight;		
    } 
	public set treeHeight(v){   
        this._treeHeight = v;	    
        this.refresh();		
    }
	public get treeHeight(){   
        return this._treeHeight;		
    }      
 	public set trunkDia(v){   
        this._trunkDia = v;	    
        this.refresh();		
    }
	public get trunkDia(){   
        return this._trunkDia;		
    }           
    public set trunkColor(val:string){
        this._trunkColor = val;
        this.trunkMatl = new THREE.MeshPhongMaterial( { color:this._trunkColor } );
        this.trunk_m.material = this.trunkMatl;
    }
    public get trunkColor(){
        return this._trunkColor;
    }
    public set leafColor(val:string){
        this._leafColor = val;
        this.layerMatl = new THREE.MeshPhongMaterial( { color:this._leafColor } );
        this.refresh();
    }
    public get leafColor(){
        return this._leafColor;
    }
}


